export default __webpack_public_path__ + "static/media/perivalon_1.4fba891e.webp";